import RotatingCarousel from '../../../ui/rotatingCarousel/RotatingCarousel';
import classes from './StripWidget.module.css';

const StripWidget = ({ color, className = "", classNameText = "", width, height, image, title, text, items = [], getItemLabel, renderItem, onClick }) => {
    
    return (
        <div
            className={`${classes.Widget} ${className}`}
            style={{
                background: color,
                ...(width != null && { width }),
                ...(height != null && { height }),
                ...(onClick && { cursor: 'pointer' }),
            }}
            onClick={onClick}
        >
            {image &&
                <div className={classes.ImageWrap}>
                    <img src={image} className={classes.Image} />
                    {title && <span className={classes.Title}>{title}</span>}
                </div>
            }
            {items.length > 0 ?
                <div className={classes.CarouselWrap}>
                    <RotatingCarousel
                        items={items}
                        getItemLabel={getItemLabel}
                        renderItem={renderItem}
                    />
                </div>
                : text ?
                    <span className={`${classes.Text} ${classNameText}`}>{text}</span>
                    : null
            }
        </div>
    );
};

export default StripWidget;